<nav class="dws-menu">
  <input class="toggleMenu" id="menu" name="toggle" type="checkbox" />
  <label class="toggleMenu" for="menu"> </label>

  <div
    [@animationForm]="sizeMenuClass"
    [ngClass]="sizeMenuClass"
    class="mainMenu"
    id="mainMenu"
  >
    <ng-container *ngFor="let m of getVisibleMenu(menu); let i = index">
      <div
        #rlaExpand="routerLinkActive"
        [routerLinkActive]="['is-active-expand']"
      >
        <div
          *ngIf="m.children && m.children.length; else noChildren"
          class="menu-item-wrapper"
        >
          <div
            (click)="expand(m)"
            (mouseenter)="onMenuItemHover(m, $event)"
            (mouseleave)="onMenuItemLeave()"
            [ngClass]="{ expanded: m.expanded }"
            class="menu-item expand-item childrens"
          >
            <app-icon
              [color]="
                sizeMenuClass === 'small' && rlaExpand.isActive
                  ? '#ffffff'
                  : 'var(--blue-text)'
              "
              [iconName]="m.iconName"
              [icon]="m.icon"
              [size]="22"
              [strokeOnly]="true"
              [title]="m.header | translate"
              class="icon"
            ></app-icon>

            <span
              [@animationForm]="sizeMenuClass === 'small' ? 'tsmall' : 'tbig'"
              class="title"
            >
              {{ m.header | translate }}
            </span>
            <fa-icon
              *ngIf="m.children"
              [@animationForm]="sizeMenuClass === 'small' ? 'tsmall' : 'tbig'"
              [icon]="['fas', m.expanded ? 'chevron-up' : 'chevron-down']"
              class="icon-expand"
            ></fa-icon>

            <!--Small Sub Menu (hover popup in collapsed mode) - Classic design only -->
            <div *ngIf="design !== 'modern'" class="submn">
              <div
                *ngFor="
                  let subm of getVisibleMenu(m.children);
                  let subi = index
                "
              >
                <a [routerLink]="subm.url">
                  <fa-icon [icon]="['fas', 'circle']" class="icon"></fa-icon>
                  <span class="title">
                    {{ subm.header | translate }}
                  </span>
                </a>
              </div>
            </div>
          </div>

          <!--Big Sub Menu-->
          <div
            *ngFor="let subm of getVisibleMenu(m.children); let subi = index"
            [ngClass]="{
              'is-invisible': sizeMenuClass === 'small' || !m.expanded
            }"
            [routerLinkActive]="['is-active']"
            class="submenu menu-item-wrapper"
          >
            <a [routerLink]="subm.url" class="menu-item">
              <ng-container *ngIf="design === 'modern'; else classicChildTpl">
                <span class="pill">
                  <fa-icon
                    [icon]="['fas', 'circle']"
                    class="icon sub-dot"
                  ></fa-icon>
                  <span
                    [@animationForm]="
                      sizeMenuClass === 'small' ? 'tsmall' : 'tbig'
                    "
                    class="title"
                  >
                    {{ subm.header | translate }}
                  </span>
                </span>
              </ng-container>
              <ng-template #classicChildTpl>
                <fa-icon [icon]="['fas', 'circle']" class="icon"></fa-icon>
                <span
                  [@animationForm]="
                    sizeMenuClass === 'small' ? 'tsmall' : 'tbig'
                  "
                  class="title"
                >
                  {{ subm.header | translate }}
                </span>
              </ng-template>
            </a>
          </div>
        </div>

        <ng-template #noChildren>
          <div [routerLinkActive]="['is-active']" class="menu-item-wrapper">
            @if (design === 'classic') {
              <a
                [routerLinkActive]="['is-active']"
                [routerLink]="m.url"
                class="menu-item"
              >
                <fa-icon
                  [icon]="m.icon"
                  class="icon"
                  title="{{ m.header | translate }}"
                ></fa-icon>

                <span
                  [@animationForm]="sizeMenuClass === 'small' ? 'tsmall' : 'tbig'"
                  class="title"
                >
                  {{ m.header | translate }}
                </span>
              </a>
            } @else {
              <a
                #rlaItem="routerLinkActive"
                [routerLinkActive]="['is-active']"
                [routerLink]="m.url"
                class="menu-item"
              >
                <app-icon
                  [color]="rlaItem.isActive ? '#ffffff' : 'var(--blue-text)'"
                  [iconName]="m.iconName"
                  [icon]="m.icon"
                  [size]="22"
                  [strokeOnly]="true"
                  [title]="m.header | translate"
                  class="icon"
                ></app-icon>

                <span
                  [@animationForm]="sizeMenuClass === 'small' ? 'tsmall' : 'tbig'"
                  class="title"
                >
                  {{ m.header | translate }}
                </span>
              </a>
            }
          </div>
        </ng-template>
      </div>
    </ng-container>

    <div *ngIf="design !== 'modern'" class="menu-item-wrapper">
      <a (click)="logout()" [routerLink]="['/']" class="menu-item">
        <fa-icon
          [icon]="['fas', 'door-open']"
          class="icon"
          title="{{ 'layouts.navigation.EXIT' | translate }}"
        ></fa-icon>

        <span
          [@animationForm]="sizeMenuClass === 'small' ? 'tsmall' : 'tbig'"
          class="title"
        >
          {{ "layouts.navigation.EXIT" | translate }}
        </span>
      </a>
    </div>
  </div>
</nav>
